/**
 * Who counts as Tagada staff (A4): any Tagada role **and** no white-label
 * scope. A partner's own team (`partneradmin`, `payment_ops`, `rx_*` with a
 * partner scope) is platform usage, not staff (`docs/iam-model.md`).
 */
export function isStaff(
  tgdRoles: readonly string[] | null | undefined,
  whitelabelOwnership: string | null | undefined,
): boolean {
  const hasRole = Array.isArray(tgdRoles) && tgdRoles.some((role) => typeof role === 'string' && role.trim() !== '');
  if (!hasRole) return false;
  return whitelabelOwnership === null || whitelabelOwnership === undefined || whitelabelOwnership.trim() === '';
}
